module.exports = __webpack_public_path__ + "images/dir-small-6e362ca556ee1a5dae885c51da17e326.png";